import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form, DatePicker } from 'antd';
import { useForm } from "antd/lib/form/Form";
import Button from "components/button";
import FormItem from "components/fields/FormItem";
import AddressFilter from "components/search/AddressFilter";
import { DATE_FORMAT } from '../../variables/constants';
import { FormatDateValue, buildFilters } from "../../utils/index";
import { 
	getRegisteredUsersChart,
	getRegisteredAnimalsChart, 
	getAnimalsStatusChart, 
	getWidgetData, 
	getTopFarmers, 
	getFarmLocations, 
} from "../../redux/dashboard/dashboardState";
import APIService from '../../services/apiservice';

const { RangePicker } = DatePicker;

function DashboardSearchFilter({ applyFilters, filters, 
	searchRegisteredUsers,
	searchRegisteredAnimals,
	searchAnimalsStatus,
	searchWidgetData,
	searchTopFarmers,
	searchFarmLocations,
	withDateRange=true, withAddress=true,
	...props }) {

  	const [form] = useForm();
	
	useEffect(() => {
		if (filters) {
			const { date_from, date_to, ...rest } = filters;
			form.setFieldsValue({
			...rest,
			date_range: date_from && date_to
				? [FormatDateValue(date_from), FormatDateValue(date_to)]
				: undefined,
			});

			onSubmit(form.getFieldsValue());
		}
	}, [filters, form]);

  	const onSubmit = (formData) => {
		formData.date_from = formData.date_range?.[0]?.format(DATE_FORMAT) || null;
    	formData.date_to = formData.date_range?.[1]?.format(DATE_FORMAT) || null;

		const filterData = buildFilters(formData);
		APIService.setDashboardFilters(filterData);

		searchRegisteredUsers(filterData);
		searchRegisteredAnimals(filterData);
		searchAnimalsStatus(filterData);
		searchWidgetData(filterData);
		searchTopFarmers(filterData);
		searchFarmLocations(filterData);
	}

	const resetFilters = () => {
		form.resetFields();
		onSubmit({});
	}

  return (
	<div>
		<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
			layout="vertical"
			onFinish={onSubmit}
		>
			{withDateRange && 
			<div className="border-y py-2">
				<h2 className="font-black">By Date</h2>
				<FormItem 
					name="date_range"
					label="Date Range"
				>
					<RangePicker className="font-normal"
						format={DATE_FORMAT}
						style={{
							width: 250,
						}}
					/>             
				</FormItem>
			</div>
			}
			{withAddress && 
			<>
				<div className="border-y py-2">
					<h2 className="font-black">By Location</h2>
					<AddressFilter className="form-column-4" form={form} filters={filters}/>
				</div>

				<div className="dark:bg-intsamis-900 text-right mt-4">
					<Button type="button" className="mx-3 min-w-[100px] text-center " onClick={resetFilters}>
						Reset
					</Button>
					<Button type="submit" className="mx-3 min-w-[100px] text-center ">
						Apply
					</Button>
				</div>
			</>
			}
		</Form>
	</div>
  );
}

const mapStateToProps = (state) => ({
	filters: state.dashboard.dashboardFiters,
});

const mapDispatchToProps = (dispatch) => ({
  searchRegisteredUsers: (filters) => dispatch(getRegisteredUsersChart(filters)),
  searchRegisteredAnimals: (filters) => dispatch(getRegisteredAnimalsChart(filters)),
  searchAnimalsStatus: (filters) => dispatch(getAnimalsStatusChart(filters)),
  searchWidgetData: (filters) => dispatch(getWidgetData(filters)),
  searchTopFarmers: (filters) => dispatch(getTopFarmers(filters)),
  searchFarmLocations: (filters) => dispatch(getFarmLocations(filters)),
  
});


export default connect(mapStateToProps, mapDispatchToProps)(DashboardSearchFilter);
